import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareReportsControlRoute: InvariantJiraRoute = {
	name: 'software-reports-control',
	path: '/jira/software/projects/:projectKey/boards/:boardId/reports/control',
};
